"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  SHOW_WEB3_CONFIRM_MODAL: 'showWeb3Wallet',
  SHOW_TX_CONFIRM_MODAL: 'showTxConfirmModal',
  SHOW_MSG_CONFIRM_MODAL: 'showMessageConfirmModal',
  SHOW_TX_SIGN_MODAL: 'showTxSignModal',
  WALLET_NOT_CONNECTED: 'walletNotConnected',
  ERROR_NOTIFY: 'errorNotify'
};
exports.default = _default;